import React, { Fragment } from 'react';

class Relationship extends React.Component {
  render(){
    return <Fragment>
      <p>
      OVC is formed by thirteen cofounders, seven of them are Oxford graduates, mostly
      from the MSc in Major Programme Management. The other five cofounders are
      bioscientists, university professors, the founder of an investment management
      company, and a US patent lawyer. The chairman is Dr. Matthew Daniels, Honorary
      Consultant Cardiologist and Wellcome Trust Fellow at the University of Oxford.
      </p>
      <p>
      OVC works closely with university-originated venture funds and other investment
      managers who have experience in life science growth investments and late-stage biopharma
      buyouts.
      </p>
    </Fragment>;

  }
}

export default Relationship;
